module.exports = __webpack_public_path__ + "static/media/bursts_27.0b7fce9f.svg";